import React, { useEffect, useRef } from "react";
import { Toast } from "bootstrap";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { Portal } from "../components/Portal";

const MsgNotificationToast = ({ show, data, onClose }) => {
  const toastRef = useRef(null);
console.log("Data Noti===>",data)
  // const navigate = useNavigate();
  useEffect(() => {
    if (show && toastRef.current) {
      const bootstrapToast = new Toast(toastRef.current);
      // const bootstrapToast = new Toast(toastRef.current, {
      //   autohide: true,
      //   delay: 300000, // 5 minutes in milliseconds
      // });
      bootstrapToast.show();

      const element = toastRef.current;
      const handleHide = () => onClose(data.id);
      element.addEventListener("hidden.bs.toast", handleHide);

      return () => {
        element.removeEventListener("hidden.bs.toast", handleHide);
      };
    }
  }, [show, data, onClose]);

  if (!show) return null;

  console.log("data.bigPicture",   data.message);

  return (
    <Portal layer="toast">
    <div
      className="wlj-app-toast position-fixed bottom-0 end-0 p-3"
      style={{ zIndex: 300000 }}
    >
      <div 
        className="toast fade show no-border-radius mb-2"
        ref={toastRef}
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        style={{ width:"300px"}}
      >
        {/* <div className="toast-header text-white success-toast">
                    <strong className="me-auto">Notification</strong>
                    <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="toast"
                        aria-label="Close"
                    ></button>
                </div> */}

              <div className="toast-body toast-body-msg d-flex justify-content-between ">
                      <div style={{width:'-webkit-fill-available'}} className="f-14"
                      //  onClick={() => navigate(`/Message/${data.receiverUid}`)}
                       >
                      
                        {/* <Link  to={`/Message/${data.receiverUid}`} > */}
                        {/* <small className="f-600"> */}
                          {"New Message : " + (data.msg?.length > 15 ? data.msg.slice(0, 15) + "..." : data.msg)}
                        {/* </small> */}

                      </div> 
                      <div>          
                <CloseSharpIcon
                style={{fontSize: "18px", fontWeight:"600"}}
                                  className="pointer"
                                  onClick={() => {
                                   onClose()
                                  }}
                                />
                </div>
              </div>

      </div>
    </div>
    </Portal>
  );
};

export default MsgNotificationToast;

